import { isMatchingMedia } from '../helpers';

export const autoSliderIntervalIds = [];

export const Slider = slide => {
  const previousButton = slide.querySelector('.js-prev');
  const nextButton = slide.querySelector('.js-next');
  const carouselSlide = slide.querySelector('.js-carousel-wrapper');
  const carouselImages = slide.querySelectorAll('.js-slide');
  const storyLinesContainer = slide.querySelector('.js-story-line-wrapper');
  const linesWrapper = slide.querySelector('.js-lines-container');
  const activeColor = slide.querySelector('.js-lines-container')?.dataset.active;
  const dotClasses = slide.querySelector('.js-lines-container')?.dataset.styles
    ? JSON.parse(slide.querySelector('.js-lines-container').dataset.styles)
    : '';

  const { mobileChunkSize, desktopChunkSize } = slide.dataset;
  const isMobile = isMatchingMedia('(max-width:768px)');

  // The count of images displayed at once
  const chunksPerSlide = isMobile ? +mobileChunkSize : +desktopChunkSize;

  const slideElement = isMobile ? carouselImages[0] : carouselSlide;

  let counter = 0;
  let movesCounter = 0;
  let storyLinesCounter = -1;

  let startX = 0;
  let endX = 0;
  let initialX = 0;
  let finalX = 0;

  cloneChunks();
  carouselSlide.addEventListener('transitionend', desktopHandleTransitionEnd);
  nextSlide();
  if (slide.classList.contains('js-automatic-carousel')) {
    startAutomaticSliding();
    return;
  }

  makeDots(carouselImages.length / chunksPerSlide, linesWrapper);
  attachDraggableEventListeners();
  nextButton.addEventListener('click', nextSlide);
  previousButton.addEventListener('click', previousSlide);

  function desktopHandleTransitionEnd() {
    if (carouselSlide.children[counter].classList.contains('js-first-slide')) {
      carouselSlide.style.transition = 'none';
      counter -= carouselImages.length;
      movesCounter -= carouselImages.length / chunksPerSlide;
      if (storyLinesContainer) {
        storyLinesContainer.style.transition = 'none';
        storyLinesCounter = movesCounter - 1;
      }

      slider();
    }

    if (carouselSlide.children[counter].classList.contains('js-last-slide')) {
      carouselSlide.style.transition = 'none';
      counter += carouselImages.length;
      movesCounter += carouselImages.length / chunksPerSlide;
      if (storyLinesContainer) {
        storyLinesContainer.style.transition = 'none';
        storyLinesCounter = movesCounter - 1;
      }

      slider();
    }
  }

  function nextSlide() {
    if (counter === carouselSlide.children.length - chunksPerSlide) return;
    counter += chunksPerSlide;
    movesCounter++;
    carouselSlide.style.transition = 'transform 0.4s ease-in-out';
    if (storyLinesContainer) {
      storyLinesCounter++;
      storyLinesContainer.style.transition = 'transform 0.4s ease-in-out';
    }

    slider();
  }

  function previousSlide() {
    if (counter === 0) return;
    counter -= chunksPerSlide;
    movesCounter--;
    carouselSlide.style.transition = 'transform 0.4s ease-in-out';
    if (storyLinesContainer) {
      storyLinesCounter--;
      storyLinesContainer.style.transition = 'transform 0.4s ease-in-out';
    }

    slider();
  }

  function startAutomaticSliding() {
    const intervalId = setInterval(() => {
      nextSlide();
    }, 3000);
    autoSliderIntervalIds.push(intervalId);
  }

  function slider() {
    const transformSize = getTransformSize(slideElement, movesCounter);
    carouselSlide.style.transform = `translateX(${transformSize}px)`;
    storyLinesContainer && moveStory();
    linesWrapper && moveLines();
  }

  function moveStory() {
    const transformSize = getTransformSize(storyLinesContainer.children[0], storyLinesCounter);
    storyLinesContainer.style.transform = `translateX(${transformSize}px)`;
    [...storyLinesContainer.children].forEach((e, i) => {
      i === storyLinesCounter + 1
        ? storyLinesContainer.children[i].classList.remove('opacity-40')
        : storyLinesContainer.children[i].classList.add('opacity-40');
    });
  }

  function getTransformSize(element, counter) {
    let translateSlideSize;
    let slideSize = element.clientWidth;
    if (document.dir === 'rtl') translateSlideSize = slideSize * counter;
    if (document.dir === 'ltr') translateSlideSize = -slideSize * counter;
    return translateSlideSize;
  }

  function moveLines() {
    [...linesWrapper.children].forEach((element, index) => {
      index === movesCounter - 1 ? element.classList.add(activeColor) : element.classList.remove(activeColor);
    });
  }

  function cloneChunks() {
    const firstChunk = Array.from(carouselImages)
      .slice(0, chunksPerSlide)
      .map(slide => {
        slide = slide.cloneNode(true);
        slide.classList.add('js-first-slide');
        return slide;
      });
    carouselSlide.append(...firstChunk);

    const lastChunk = Array.from(carouselImages)
      .reverse()
      .slice(0, chunksPerSlide)
      .map(slide => {
        slide = slide.cloneNode(true);
        slide.classList.add('js-last-slide');
        return slide;
      });
    lastChunk.forEach(slide => carouselSlide.insertBefore(slide, carouselSlide.children[0]));
  }

  function makeDots(dotsCount, parent) {
    for (let i = 0; i < dotsCount; i++) {
      let dot = document.createElement('span');
      if (i === 0) {
        dot.classList.add(activeColor, ...dotClasses, 'js-line', 'line');
      } else {
        dot.classList.add(...dotClasses, 'js-line', 'line');
      }
      parent.appendChild(dot);
    }
  }

  function attachDraggableEventListeners() {
    const draggable = slide.querySelector('.js-draggable-area');
    if (draggable) {
      draggable.addEventListener('touchstart', handleTouchStart);
      draggable.addEventListener('touchmove', handleTouchMove);
      draggable.addEventListener('touchend', handleTouchEnd);
      draggable.addEventListener('dragstart', handleDragStart);
      draggable.addEventListener('dragend', handleDragEnd);
    }
  }

  function handleDragStart(event) {
    startX = event.clientX;
  }

  function handleDragEnd(event) {
    endX = event.clientX;
    if (document.dir === 'ltr') endX > startX ? previousSlide() : nextSlide();
    if (document.dir === 'rtl') endX < startX ? previousSlide() : nextSlide();
    startX = 0;
    endX = 0;
  }

  function handleTouchStart(event) {
    initialX = event.touches[0].clientX;
  }

  function handleTouchMove(event) {
    finalX = event.touches[0].clientX;
  }

  function handleTouchEnd() {
    const delta = finalX - initialX;
    const threshold = 50;
    if (delta > threshold) {
      document.dir === 'ltr' ? previousSlide() : nextSlide();
    } else if (delta < -threshold) {
      document.dir === 'ltr' ? nextSlide() : previousSlide();
    }

    finalX = 0;
    initialX = 0;
  }
};

document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);

export function handleDOMContentLoaded() {
  const sliders = document.querySelectorAll('.js-carousel-container');
  [...sliders].forEach(slider => {
    const intervalId = setInterval(() => {
      const hasWidth = slider.clientWidth !== 0;
      if (hasWidth) {
        clearInterval(intervalId);
        Slider(slider);
        document.dispatchEvent(new Event('carousel-loaded'));
      }
    }, 60);
  });
}
